import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "pdf-reader w-full"
};
import { ref, watch, nextTick } from 'vue';
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist';
import { promiseTimeout } from '@vueuse/core';
export default /*@__PURE__*/_defineComponent({
  __name: 'pdfReader',
  props: {
    pdfUrl: {},
    autoRender: {
      type: Boolean
    },
    isSwitch: {
      type: Boolean
    },
    delay: {}
  },
  emits: ["renderOver", "renderError"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const loading = ref(false);
    const pdfViewer = ref(null);
    const scrollBoxRef = ref(null);
    let pdfDoc = null;
    const pageNum = ref(1);
    const totalPages = ref(0);
    const canvasMap = new Map();
    const scale = ref(0);
    const renderPdfByNum = async () => {
      const num = pageNum.value;
      try {
        let canvas = canvasMap.get(num);
        if (!canvas) {
          const page = await pdfDoc.getPage(num);
          if (!scale.value) {
            const containerWidth = pdfViewer.value?.clientWidth || 600;
            scale.value = containerWidth / page.getViewport({
              scale: 1
            }).width;
          }
          const viewport = page.getViewport({
            scale: scale.value,
            dontAdjustForDPIScale: true,
            // 启用图像平滑（避免水印模糊）
            imageSmoothingEnabled: true
          });
          canvas = document.createElement('canvas');
          const context = canvas.getContext('2d', {
            // 启用透明度支持
            alpha: true,
            // 启用图像平滑
            imageSmoothingQuality: 'high'
          });
          if (!context) {
            throw new Error('无法创建canvas上下文');
          }
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          if (props.isSwitch) pdfViewer.value.innerHTML = '';
          pdfViewer.value?.appendChild(canvas);
          const renderContext = {
            canvasContext: context,
            viewport
          };
          await page.render(renderContext).promise;
          canvasMap.set(num, canvas);
        } else {
          if (props.isSwitch) pdfViewer.value.innerHTML = '';
          pdfViewer.value?.appendChild(canvas);
        }
        if (props.autoRender) {
          // eslint-disable-next-line no-use-before-define
          handleRenderOver();
        }
        emits('renderOver', num);
      } catch (error) {
        emits('renderError', num);
        console.error('PDF渲染失败:', error);
      } finally {
        loading.value = false;
      }
    };
    const prev = async () => {
      if (pageNum.value > 1) {
        pageNum.value -= 1;
        await renderPdfByNum();
      }
    };
    const next = async () => {
      if (pageNum.value < totalPages.value) {
        pageNum.value += 1;
        await renderPdfByNum();
      }
    };
    const handleScroll = e => {
      const {
        scrollHeight,
        clientHeight,
        scrollTop
      } = e.target;
      if (scrollHeight < clientHeight + scrollTop + 50) {
        next();
      }
    };
    const handleRenderOver = () => {
      if (scrollBoxRef.value) {
        const {
          scrollHeight,
          clientHeight
        } = scrollBoxRef.value;
        if (scrollHeight === clientHeight && pageNum.value < totalPages.value) {
          next();
        }
      }
    };
    const handlePdfLoad = async url => {
      try {
        loading.value = true;
        GlobalWorkerOptions.workerSrc = '/plugins/pdf.worker.js';
        const loadingTask = getDocument({
          url,
          cMapUrl: '/plugins/cmaps/',
          standardFontDataUrl: '/plugins/standard_fonts/',
          cMapPacked: true,
          wasmUrl: '/plugins/wasm/'
        });
        pdfDoc = await loadingTask.promise;
        totalPages.value = pdfDoc.numPages;
        if (totalPages.value > 1) {
          pageNum.value = 1;
        }
        renderPdfByNum();
      } catch (error) {
        loading.value = false;
        emits('renderError', 0);
        console.error('PDF加载失败:', error);
      }
    };
    watch(() => props.pdfUrl, async newVal => {
      if (newVal) {
        canvasMap.clear();
        await nextTick();
        if (props.delay) await promiseTimeout(props.delay);
        pdfViewer.value.innerHTML = '';
        scale.value = 0;
        // let url = 'https://img03.71360.com/w3/k4vde5/20250331/ac62915e02f74672291bab3cbaec3bd6.pdf'
        handlePdfLoad(newVal);
      }
    }, {
      immediate: true
    });
    __expose({
      totalPages,
      pageNum,
      renderPdfByNum,
      next,
      prev
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "scroll-box pdf-preview",
        style: _normalizeStyle({
          'overflow-y': __props.autoRender ? 'auto' : 'hidden'
        }),
        ref_key: "scrollBoxRef",
        ref: scrollBoxRef,
        onScroll: handleScroll
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "pdf-viewer",
        ref_key: "pdfViewer",
        ref: pdfViewer
      }, null, 512)])], 36);
    };
  }
});